/// <amd-module name="TFS/Msal/TfsMsalPopupDialog" />
import * as React from "react";

import { AuthenticationResult } from "@azure/msal-browser";
import * as Resources from "TFS/Msal/Resources";
import { Dialog } from "VSSUI/Dialog";

export interface ITfsMsalPopupDialogProps {
    openPopup: () => Promise<AuthenticationResult>;
    onDismiss: () => void;
    onReject: (reason?: any) => void;
    onResolve: (value: AuthenticationResult | PromiseLike<AuthenticationResult>) => void;
}

export const TfsMsalPopupDialog = (props: ITfsMsalPopupDialogProps) => {
    const { openPopup } = props;

    return (
        <Dialog
            footerButtonProps={[
                {
                    onClick: async () => {
                        try {
                            const authenticationResult = await openPopup();
                            props.onResolve(authenticationResult);
                        }
                        catch (error) {
                            props.onReject(error);
                        }
                        finally {
                            props.onDismiss();
                        }
                    },
                    primary: true,
                    text: Resources.OpenPopup
                }
            ]}
            lightDismiss={false}
            onDismiss={() => {
                props.onReject("dialog dismissed");
                props.onDismiss();
            }}
            titleProps={{ text: Resources.DialogTitle }}
        >
            <p>{Resources.ReauthenticationDialogText}</p>
            <p>{Resources.PopupBlockedMessage}</p>
        </Dialog>
    );
}
